export default __webpack_public_path__ + "static/media/cat_jachtwerf.b03d86d0.svg";